import React from 'react'
import PropTypes from 'prop-types'
import TextField from './TextField'
import { FieldType } from '../Types/Field'
import * as R from 'ramda'

const NumberTextField = ({ value, onChange, min, max, error, ...other }) => {
  return (
    <TextField
      value={value}
      onChange={(evt) => {
        const value = R.isEmpty(evt.target.value) ? null : parseFloat(evt.target.value)
        if (R.not(R.isNil(max)) && R.not(R.isNil(value)) && R.gt(value, max)) return null
        onChange({ ...evt, target: { ...evt.target, value } })
      }}
      type='number'
      error={error || R.not(R.isNil(min)) && value < min}
      {...other}
    />
  )
}

NumberTextField.defaultProps = {
  min: PropTypes.number,
  max: PropTypes.number,
}

NumberTextField.propTypes = FieldType

export default NumberTextField
